import { ServicePortSubscriptionType } from "../gql/generated-ingestor";

export interface SubscriptionMessageUpdate {
  timestamp: number;
  description: string;
}

export interface AffectedSubscription {
  product_type: string;
  subscription_id: string;
  name: string;
  description: string;
  customer_description: string;
  impact_type: string;
}
export interface SubscriptionMessage {
  id: number;
  cursor: string;
  heading: string;
  summary: string;
  contents: string;
  category: string;
  urgency: string;
  start_timestamp: number;
  end_timestamp: number;
  timestamp: number;
  tags: string[];
  updates: SubscriptionMessageUpdate[];
  affected_subscriptions: AffectedSubscription[];
  // to satisfy SurfNotification
  impact_type: string;
  _timestamp: number;
  notificationIconType: string;
  toasterColor: string;
}

export interface SubscriptionDetails {
  description: string;
  subscriptionId: string;
  location: any;
  l3vpnsapss: any;
  esis: any;
  portMode: string;
  circuits: any[];
  saps: { port: { address: { city: string; street: string; number: string } } }[];
  address: any;
  services: any[];
  product: any;
  ipGateway: any;
  portSpeed: number;
  productType?: string;
}
/**
 * The base subscription as defined by the API.
 */
export interface BaseSubscription {
  subscriptionId: string;
  name: string;
  customerId: string;
  status: string;
  customerDescriptions: string[];
  tags: string[];
  description: string;
  startDate: number;
  endDate: number;
  product: any;
  organisation: string;
  serviceSpeed: number;
  health: any;
  meta: SubscriptionDetails;
}

export interface ChartFilterType {
  vlanranges: any;
  connection: any;
  port?: any;
}

export interface MalfunctionFilterType {
  loadMoreActive: boolean;
  hasMore: boolean;
  filterStartDate: any;
  filterEndDate: any;
  productType: any;
  subscriptionId: any;
  subscriptionName: string;
}

export interface MalfunctionDateChangeType {
  filterDate: Date;
}

export interface SlsDialogPayload {
  subscription: any;
}

export interface DdosFilteredTraffic {
  ddos_stat: number[][];
  name: string;
}

export type NotificationSetting = "Down" | "Loss of Resiliency" | "Reduced Redundancy" | "Never";

export type ExtendedServicePortSubscriptionType = ServicePortSubscriptionType & {
  metadata: any;
};

export interface NWDMaintenanceBanner {
  enabled: boolean;
  title?: string;
  contents?: string;
}

export interface NWDUserConfig {
  oauthEnabled: boolean;
  oauthAuthorizeUrl: string;
  clientId: string;
  redirectUri: string;
  wellKnownUrl: string;
  issuer: string;
  loa: string;
  maintenanceBanner: NWDMaintenanceBanner;
  selfServiceEnabled: boolean;
}

export const EMPTY_CONFIGURATION: NWDUserConfig = {
  oauthEnabled: true,
  oauthAuthorizeUrl: "",
  clientId: "",
  redirectUri: "",
  wellKnownUrl: "",
  issuer: "",
  loa: "",
  maintenanceBanner: {
    enabled: false,
    title: "",
    contents: "",
  },
  selfServiceEnabled: false,
};

export interface OidcTokenResult {
  exp: number;
  iat: number;
  auth_time: number;
  jti: string;
  iss: string;
  aud: string;
  sub: string;
  typ: string;
  azp: string;
  nonce: string;
  sid: string;
  at_hash: string;
  acr: string;
  email_verified: boolean;
  user_name: string;
  name: string;
  preferred_username: string;
  given_name: string;
  authenticating_authority: string;
  family_name: string;
  eduperson_entitlement: string[];
  email: string;
}

export interface NWDUser {
  authenticatingAuthority: string;
  authorities: string[];
  displayName: string;
  eduPersonPrincipalName: string;
  email: string;
  customerId: string;
  organizationName: string;
  teams: string[];
  roles: string[];
}

export const EMPTY_USER = {
  authenticatingAuthority: "",
  authorities: [],
  displayName: "",
  eduPersonPrincipalName: "",
  email: "",
  customerId: "",
  organizationName: "",
  teams: [],
  roles: [],
};
